module.exports = __webpack_public_path__ + "staticPO/img/BG1.a2ac3b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BGImages/BG1.jpg
// module id = +jLU
// module chunks = 1